'use client';

import { TroubleShootComp } from 'components/TroubleShootComp';

export default function TroubleShootClient() {

  return <TroubleShootComp />;
}
